<template>
    <div class="adminUserList">
        <Breadcumb title="Options d'enquête" :breadcumb-data="breadcumbData"></Breadcumb>
        <form @submit="savePartnerOption" class="cardcontainer">
            <b-card no-body class="mt-4 mb-4">
                <!-- Table controls -->
                <b-card-body>
                    <div class="row">
                        <div class="col-md-2">
                            <b-form-radio v-model="partner" name="partner" value="directobea"></b-form-radio>
                        </div>
                        <div class="col-md-6">
                            Transmettre directement à OBEA
                        </div>
                        <div class="col-md-4">
                            <img :src="require('@/assets/logo_opengraph.png')" style="height:30px;"/>
                        </div>
                    </div>
                </b-card-body>
            </b-card>
            <b-card no-body class="mt-4 mb-4">
                <!-- Table controls -->
                <b-card-body>
                    <div class="row">
                        <div class="col-md-2">
                            <b-form-radio v-model="partner" name="partner" value="estimateobea"></b-form-radio>
                        </div>
                        <div class="col-md-6">
                            Demander un devis à OBEA
                        </div>
                        <div class="col-md-4">
                            <img :src="require('@/assets/logo_opengraph.png')" style="height:30px;"/>
                        </div>
                    </div>
                </b-card-body>
            </b-card>
            <b-card no-body class="mt-4 mb-4">
                <!-- Table controls -->
                <b-card-body>
                    <div class="row">
                        <div class="col-md-2">
                            <b-form-radio v-model="partner" name="partner" value="otherpartner"></b-form-radio>
                        </div>
                        <div class="col-md-6">
                            Passer par un prestataire externe
                        </div>
                        <div class="col-md-4">
                            <b-input type="text" placeholder="Email du partenaire" v-model="email"/>
                        </div>
                    </div>
                </b-card-body>
            </b-card>
            <b-btn type="submit" variant="primary">Enregister mes options </b-btn>
        </form>

    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import Breadcumb from '../components/breadcumb'
    import { SURVEY_SAVE_OPTION_REQUEST } from '../_store/survey/actiontypes';
    import {USER_REQUEST} from "../_store/user/actiontypes";
    export default {
        name: 'adminUserList',
        mounted() {
            this.$store.dispatch(USER_REQUEST)
                .then(response => {
                    let user = response.data.user;
                    this.partner = user.userprofile.company.survey_option;
                    this.email = user.userprofile.company.partner_email
                })

        },
        components: { Breadcumb, },
        data() {
            return {
                partner:'',
                email: '',
                breadcumbData: [
                    { text: 'Accueil', href: '/dashboard/' },
                    { text: 'Options d\'enquête', active: true },
                ],
            };
        },
        layout(context) {
            return 'layout';
        },
        methods: {
            savePartnerOption: function (e) {
                e.preventDefault();
                this.$store.dispatch(SURVEY_SAVE_OPTION_REQUEST, {
                    survey_option: this.partner,
                    email: this.email,
                })
            }
        },
    };
</script>
